import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import {
  LayoutDashboard, Users, BarChart3, LogOut, GraduationCap, TrendingUp, BookOpen
} from 'lucide-react';

const nav = [
  { path: '/admin', label: 'Inicio', icon: LayoutDashboard },
  { path: '/admin/crm', label: 'CRM Leads', icon: BarChart3 },
  { path: '/admin/users', label: 'Usuarios', icon: Users },
  { path: '/admin/cohorts', label: 'Camadas', icon: GraduationCap },
  { path: '/admin/linkedin', label: 'LinkedIn', icon: TrendingUp },
  { path: '/admin/progress', label: 'Progreso', icon: BookOpen },
];

export default function AdminLayout() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-gray-100 flex">
      {/* Sidebar */}
      <aside className="w-56 bg-slate-800 text-white flex flex-col shrink-0">
        <div className="p-4 border-b border-slate-700">
          <Link to="/admin" className="font-semibold text-lg text-white hover:text-slate-200">
            Panel Admin
          </Link>
        </div>
        <nav className="p-2 flex-1">
          {nav.map(({ path, label, icon: Icon }) => {
            const isActive = path === '/admin' ? location.pathname === '/admin' : location.pathname.startsWith(path);
            return (
              <Link
                key={path}
                to={path}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                  isActive ? 'bg-purple-600 text-white' : 'text-slate-300 hover:bg-slate-700 hover:text-white'
                }`}
              >
                <Icon className="w-5 h-5 shrink-0" />
                {label}
              </Link>
            );
          })}
        </nav>
        <div className="p-2 border-t border-slate-700">
          <Link
            to="/"
            className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-slate-400 hover:bg-slate-700 hover:text-white transition-colors"
          >
            <LogOut className="w-5 h-5" />
            Volver al sitio
          </Link>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
